const getFramesDisplayPrice = (variantPrice, offering) => {
  const updatedPrice = {
    originalPrice: variantPrice.originalPrice,
    discountedPrice: variantPrice?.discountedPrice,
    currency: variantPrice.currency,
    isCentAmount: variantPrice.isCentAmount
  };
  if (offering?.originalPriceInformation?.amount) {
    const offeringOriginalPrice = offering.originalPriceInformation.amount;
    const offeringDiscountPrice = offering.discountedPriceInformation?.amount;
    if (offeringDiscountPrice) {
      if (updatedPrice.discountedPrice) {
        updatedPrice.discountedPrice += offeringDiscountPrice;
      } else {
        updatedPrice.discountedPrice = updatedPrice.originalPrice + offeringDiscountPrice;
      }
    } else if (updatedPrice.discountedPrice) {
      updatedPrice.discountedPrice += offeringOriginalPrice;
    }
    updatedPrice.originalPrice += offeringOriginalPrice;
  }
  return { ...variantPrice, ...updatedPrice };
};
export {
  getFramesDisplayPrice
};
//# sourceMappingURL=get-frames-display-price.js.map
